module.exports = __webpack_public_path__ + "static/media/Artboard6.f9509ad2.png";